import type { ChartDatapoint } from '../../../core/types/chart-data.js';
import type { FlameTooltipProps } from '../types/flame-internal.js';

/**
 * @internal
 */
export const FlameChartTooltipSlot = function <
  TData extends ChartDatapoint,
  TPayload extends { datapoint: TData } = { datapoint: TData },
>(_props: FlameTooltipProps<TData, TPayload>): null {
  return null;
};
FlameChartTooltipSlot.displayName = 'FlameChart.Tooltip';
/**
 * @internal
 */
export const FlameGraphTooltipSlot = function <
  TData extends ChartDatapoint,
  TPayload extends { datapoint: TData } = { datapoint: TData },
>(_props: FlameTooltipProps<TData, TPayload>): null {
  return null;
};
FlameGraphTooltipSlot.displayName = 'FlameGraph.Tooltip';
